@if (loadingSpinnerService.isShowing()) {
  <div class="global-overlay">
    <scale-loading-spinner
      variant="white"
      alignment="vertical"
      size="large"
      [text]="loadingSpinnerService.loadingText()"
    ></scale-loading-spinner>
  </div>
}